import { Expose } from "class-transformer";

export class UnassignPlanningBoardVehicleDto {
  @Expose()
  planningBoardProjectId: string;

  @Expose()
  vehicleId: string;

  @Expose()
  updatedById: string;
}
